import httpService from '@/modules/common/services/httpService';

const gatewayService = httpService.create(window.pov_config.VUE_APP_API_URL_GATEWAY);
const channelsBasePath = 'business/messaging/v1/channels/';
const baseRoute = 'v3/communication';

const getCallsSettings = async () => gatewayService.get(`${baseRoute}/voice_call_settings`).then((res) => res.data);

const createCallsSettings = async (settings) => gatewayService.post(`${baseRoute}/voice_call_settings`, settings).then((res) => res.data);

const updateCallsSettings = async (settingsUid, updatedSettings) => gatewayService.put(`${baseRoute}/voice_call_settings/${settingsUid}`, updatedSettings).then((res) => res.data);

const getRemainingQuota = async () => gatewayService.get(`${baseRoute}/voice_call_quotas`).then((res) => res.data);

const getBusinessActiveDedicatedNumber = async (params) => {
  const result = await httpService.get(channelsBasePath, { new_api: true, provider: 'nexmo', ...params });
  return result.data.data.channels?.find((number) => (number.number_type === 'transactional')
    && (number.status === 'active' || number.status === 'inactive') && !number.pool);
};

const toggleTextingStatus = async (status) => httpService
  .put('platform/v1/numbers/dedicated_numbers/set_two_way_texting_status', { status })
  .then((res) => res);

const claimNumber = async ({ voiceTextAppInstalled }) => httpService.post(
  `${channelsBasePath}`,
  { new_api: true, channel: { provider: 'nexmo', voice_text_app_installed: voiceTextAppInstalled } },
).then((res) => res.data?.data.channel);

const getAvailablePhoneNumbers = async ({ areaCode, countryCode, page, perPage, features = '["VOICE"]' }) => gatewayService
  .get(`${baseRoute}/available_phone_numbers`, {
    country_code: countryCode,
    area_code: areaCode,
    features,
    page,
    per_page: perPage,
  })
  .then((res) => res.data?.data);

const createBusinessPhoneNumber = async({ phoneNumber, countryCode, features = ['VOICE'] }) => gatewayService
  .post(`${baseRoute}/business_phone_numbers`, {
    phone_number: phoneNumber,
    country_code: countryCode,
    features,
  });

const getBusinessPhoneNumbers = async () => gatewayService
  .get(`${baseRoute}/business_phone_numbers`)
  .then((res) => res.data?.data);

export default {
  getCallsSettings,
  createCallsSettings,
  updateCallsSettings,
  getRemainingQuota,
  getBusinessActiveDedicatedNumber,
  toggleTextingStatus,
  claimNumber,
  getAvailablePhoneNumbers,
  createBusinessPhoneNumber,
  getBusinessPhoneNumbers,
};
